import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import Workflow_popup_AddStep from "../Popups/Workflow_popup_AddStep";

export type Props = {
    workflowDefinitionId: number
}

interface WorkflowStepQueryModel {
    id: number
    title: string
    isFirstStep: boolean
    nextSteps: string
    workflowDefinitionId: number
}

const Workflow_tab_Steps: React.FC<Props> = ({ workflowDefinitionId }) => {
    const [data, setData] = useState<WorkflowStepQueryModel[]>();
    const { handleResult, handleException } = useNotifications();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { isAuthorizedForWorkflowDefinition } = useAuth();

    useEffect(() => {
        getTableData();
    }, [workflowDefinitionId]);

    function getTableData() {
        DataService.get<WorkflowStepQueryModel[]>('api/v1/WorkflowStepDefinitions/ByWorkflowDefinition/' + workflowDefinitionId)
            .then(response => {
                console.log('steps:', response)
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function canDeleteRow(rowData: WorkflowStepQueryModel): boolean {
        return isAuthorizedForWorkflowDefinition(ApplicationFunctions.UpdateWorkflowDefinition, rowData.workflowDefinitionId)
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/workflowStepDefinitions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    return (
        <>
            <DataTable
                name='dtWorkflowSteps'
                tableData={data}
                navigateTitle='Workflow Step'
                navigateUrl='/plm/WorkflowSetup/WorkflowStep/'
                colInfos={[
                    { key: true, dataProp: 'id', visible: false },
                    { title: 'Title', dataProp: 'title' },
                    { title: 'First Step', dataProp: 'isFirstStep', dataType: 'bool', trueValue: 'Yes', falseValue: 'No', sort: 'desc' },
                    { title: 'Next Steps', dataProp: 'nextSteps' },
                    { title: 'Sub-workflow', dataProp: 'subWorkflowStepDefinitionName' },
                    {
                        headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true), applicationFunctions: [ApplicationFunctions.UpdateWorkflowDefinition] }],
                        rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, isVisible: canDeleteRow }]
                    }
                ]}
            />
            {showPopup && <Workflow_popup_AddStep show={showPopup} onHide={() => { getTableData(); setShowPopup(false) }} workflowDefinitionId={workflowDefinitionId} />}
        </>
    );
}
export default Workflow_tab_Steps;
